import { Component, Inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { BsModalService } from 'ngx-bootstrap/modal';

export interface ModalDialogModel {
  title: string;
  message: string;
  isHiddenFooter?: boolean;
  modalSize?: string;
  confirmText?: string;
  isHiddenConfirmButton?: boolean;
  closeText?: string;
  continueText?: string;
  showNeverAskMeAgainOption?: boolean;
  dialogType?: string;
  showSpinner?: boolean;
  isWarning: boolean;
}

@Component({
  selector: 'bpr-modal-dialog',
  templateUrl: 'bprmodal-dialog.component.html',
  styleUrls: ['bprmodal-dialog.component.less'],
  standalone: false
})
export class ModalDialogComponent {
  title: '';
  message: '';
  isHiddenFooter: false;
  modalSize: '';
  isMessageDisplayedInTextArea = false;
  confirmText: 'Yes';
  isHiddenConfirmButton: false;
  closeText: 'No';
  isHiddenCloseButton: true;
  showNeverAskMeAgainOption = false;
  dialogType = '';
  showSpinner: boolean;
  showHeaderDivider: false;
  isWarning: boolean;

  neverShowDialogPreferenceChecked = false;

  constructor(
    @Inject(DOCUMENT) private document: any,
    private modalService: BsModalService
  ) { }

  confirm() {
    this.modalService.onHide.emit(true);
    this.modalService.hide(1);
    this.document.body.classList.remove('modal-open');
  }
  close() {
    this.modalService.onHide.emit(false);
    this.modalService.hide(1);
    this.document.body.classList.remove('modal-open');
  }
  cancel() {
    this.modalService.onHide.emit(false);
    this.modalService.hide(1);
    this.document.body.classList.remove('modal-open');
  }
}
